import VideoModal from "components/Modal/Video/VideoModal";
import Video from "components/Video/Video";
import { useTutoringContext } from "features/AssignmentTypes/Tutoring/context/TutoringContext";
import { useState } from "react";
import { Accordion, Button } from "react-bootstrap";

interface Props {
  videoTips?: Array<{
    videoId: string;
    previewImage?: string | null | undefined;
  }>;
  videoIds?: string[];
  // Dočasně: přepis videorozboru v CZ a EN, zobrazený pod videi.
  transcriptCs?: string | null;
  transcriptEn?: string | null;
  activeAccordion?: string | string[] | null;
  toggleAccordion: (open: boolean) => void;
}

export const VideoAccordion = ({
  videoIds,
  videoTips,
  transcriptCs,
  transcriptEn,
  activeAccordion,
  toggleAccordion,
}: Props) => {
  if (!videoIds && !videoTips?.length) return null;

  const [isVideoModalVisible, setVideoModalVisible] = useState(false);
  const { themeName } = useTutoringContext();

  const handleVideoModalClose = () => {
    setVideoModalVisible(false);
  };

  if (!videoIds?.length && !videoTips?.length) return null;

  return (
    <>
      <Accordion
        activeKey={activeAccordion ? "0" : undefined}
        className="my-sm-20px"
        onSelect={() => {
          toggleAccordion(!activeAccordion);
        }}
      >
        <Accordion.Item eventKey={"0"}>
          <Accordion.Header>Potřebuješ poradit? Klidně si pusť videorozbor.</Accordion.Header>
          <Accordion.Body className="pb-4">
            {videoTips?.length ? (
              <p>
                Řeš úlohu postupně. Část úlohy, která ti nejde si pak stopni a počítej. Pokud nechápeš látku, přehraj si
                znovu{" "}
                <Button
                  variant="link"
                  className="btn-link-reset"
                  onClick={() => {
                    setVideoModalVisible(true);
                  }}
                >
                  výuková videa
                </Button>
                .
              </p>
            ) : null}
            {videoIds ? (
              <div className="d-flex flex-column gap-3">
                {videoIds.map(videoId => (
                  <Video videoId={videoId} key={videoId} />
                ))}
              </div>
            ) : null}

            {/* Temporary: video analysis transcript (EN + CZ) below the videos. Content is rich text (HTML) from the CMS. */}
            {transcriptEn?.trim() ? (
              <div className="mt-4">
                <h6 className="fw-bold">Transcript (EN)</h6>
                <div dangerouslySetInnerHTML={{ __html: transcriptEn }} />
              </div>
            ) : null}
            {transcriptCs?.trim() ? (
              <div className="mt-4">
                <h6 className="fw-bold">Přepis (CZ)</h6>
                <div dangerouslySetInnerHTML={{ __html: transcriptCs }} />
              </div>
            ) : null}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      {isVideoModalVisible && videoTips?.length && themeName ? (
        <VideoModal themeName={themeName} videoTips={videoTips} onClose={handleVideoModalClose} />
      ) : null}
    </>
  );
};
